<template>
  <ConfigProvider :locale="locale">
    <RouterView v-if="showPage" />
  </ConfigProvider>
</template>

<script lang="ts">
  import { defineComponent, onMounted } from 'vue';
  import { ConfigProvider } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
  import { useRefreshPage } from './hooks/web/useRefreshPage';

  export default defineComponent({
    name: 'App',

    components: {
      ConfigProvider,
    },

    setup() {
      const { showPage } = useRefreshPage();

      onMounted(() => {});
      return {
        locale: zhCN,
        showPage,
      };
    },
  });
</script>

<style></style>
